<template>
  <div class="search-input">
    <i class="leading-icon icon-search" />
    <input
      class="searchInput"
      tabindex="0"
      type="text"
      :placeholder="placeholder"
      @input="inputOnchange($event)"
    >
  </div>
</template>

<script>
export default {
  name: "SearchInput",
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    textLabel: {
      type: String,
      default: ""
    }
  },
  methods: {
    inputOnchange($event) {
      this.$emit("input", $event.target.value);
    },
    gradientButtonOnclick() {
      this.$emit("click");
    }
  }
};
</script>
<style lang="scss" scoped>
</style>